import { article_path } from '@routes';

type TiArticleTimeLineEvent = {
  month: string;
  year: string;
  articleTitle: string;
  articleLink: string;
  topic: string;
};

type ExternalArticleTimeLineEvent = {
  month: string;
  year: string;
  articleTitle: string;
  logoPath: string;
};

export type ArticleTimeLineEvent = [TiArticleTimeLineEvent, ExternalArticleTimeLineEvent];

export type ArticleTimeLineEvents = ArticleTimeLineEvent[];

export const ARTICLE_TIME_LINE_EVENTS: ArticleTimeLineEvents = [
  [
    {
      month: 'November',
      year: '2023',
      articleTitle: 'At Tesla’s Giant Texas Factory, Injuries and Safety Lapses Mount',
      articleLink: article_path('at-teslas-giant-texas-factory-injuries-and-safety-lapses-mount'),
      topic: 'Investigation',
    },
    {
      month: 'December',
      year: '2023',
      articleTitle: 'Tesla engineer attacked by robot at company’s Giga Texas factory, report says',
      logoPath: 'brand_campaign/the-independent.png',
    },
  ],
  [
    {
      month: 'November',
      year: '2021',
      articleTitle: 'The Eternal Sunshine of Sam Altman',
      articleLink: article_path('the-eternal-sunshine-of-sam-altman'),
      topic: 'Profile',
    },
    {
      month: 'March',
      year: '2023',
      articleTitle: 'The Contradictions of Sam Altman, AI Crusader',
      logoPath: 'brand_campaign/TWSJ.png',
    },
  ],
  [
    {
      month: 'May',
      year: '2023',
      articleTitle: 'Instacart’s Ad Business Surges',
      articleLink: article_path('instacarts-ad-business-surges'),
      topic: 'Analysis',
    },
    {
      month: 'September',
      year: '2023',
      articleTitle: 'Instacart IPO Puts Spotlight on Its Evolution Into Ad Seller',
      logoPath: 'brand_campaign/Bloomberg_RTIF.png',
    },
  ],
  [
    {
      month: 'March',
      year: '2023',
      articleTitle: 'Layoff Uncertainty at Meta Makes 2023 a Year of Distraction',
      articleLink: article_path('layoff-uncertainty-at-meta-makes-2023-a-year-of-distraction'),
      topic: 'News',
    },
    {
      month: 'April',
      year: '2023',
      articleTitle: 'Mass Layoffs and Absentee Bosses Create a Morale Crisis at Meta',
      logoPath: 'brand_campaign/TNYT.png',
    },
  ],
  [
    {
      month: 'May',
      year: '2021',
      articleTitle: 'The Deadly Toll of Amazon’s Trucking Boom',
      articleLink: article_path('the-deadly-toll-of-amazons-trucking-boom'),
      topic: 'Investigation',
    },
    {
      month: 'September',
      year: '2022',
      articleTitle: 'Amazon Routinely Hired Dangerous Trucking Companies, With Deadly Consequences',
      logoPath: 'brand_campaign/TWSJ.png',
    },
  ],
];
